<tr *transloco="let t">
  <td class="fw-bold">
    <ng-container *ngIf="dayOff.dateTo; else oneDate">
      {{ isSameMonth(dayOff.date, dayOff.dateTo) ? (dayOff.date | date: 'd.') : (dayOff.date | date: 'd. M.') }} -
      {{ dayOff.dateTo | date: 'd. M.' }}
    </ng-container>
    <ng-template #oneDate>
      {{ dayOff.date | date: 'd. M.' }}
    </ng-template>
  </td>
  <td>
    {{ dayOff.name }}
  </td>
  <td>
    <app-context-menu [menuType]="MenuTypeEnum.DAY_OFF" [data]="dayOff" (refreshData)="refreshDaysOff.emit()"></app-context-menu>
  </td>
</tr>
